import { Data } from '@angular/router';

import { createAction, props } from '@ngrx/store';
import { createAsyncAction, createAsyncActionNoProps } from '@hglobal/common';

import { supportFeatureKey } from './support.state';
import {
  GetCategoriesRes,
  GetTipsReq,
  GetTipsRes,
  SendMessageReq,
  SendMessageRes,
} from '../models';

const init = createAction(`[${supportFeatureKey}]: Init`, props<{ routeData: Data }>());
const categoryId
  = createAction(`[${supportFeatureKey}]: Category id`, props<{ categoryId: number }>());
const tipType = createAction(`[${supportFeatureKey}]: Tip type`, props<{ tipType: string }>());
const getCategoriesReq
  = createAsyncActionNoProps<GetCategoriesRes>(`[${supportFeatureKey}]: Get categories`);
const getTipsReq = createAsyncAction<GetTipsReq, GetTipsRes>(`[${supportFeatureKey}]: Get tips`);
const sendMessageReq = createAsyncAction<SendMessageReq, SendMessageRes>(
  `[${supportFeatureKey}]: Send message`,
);
const navigationEnd = createAction(`[${supportFeatureKey}]: navigationEnd`);

export const SupportActions = {
  init,
  categoryId,
  tipType,
  getCategoriesReq,
  getTipsReq,
  sendMessageReq,
  navigationEnd,
};
